module.exports = __webpack_public_path__ + "static/media/search-icon.299e7a00.svg";